import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "icon/content/remove_24px", d: "M19 13H5V11H19V13Z", fill: "#696F88" }));
export default SvgMinus;
